// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Ik0I","header":"MessagesList_header__2-89J","chat":"MessagesList_chat__1zKQt"};